import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { GenericService } from '../../generic.service';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { LandingService } from '../../landing-page/service/landing.service';
import { CrowdinService } from '../../shared/service/crowdin.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-esr-support-details',
    imports: [CommonModule],
    templateUrl: './esr-support-details.component.html',
    styleUrl: './esr-support-details.component.scss'
})
export class EsrSupportDetailsComponent {
  esrSupportDetailForm!: FormGroup;
  request: string = 'close';
  isFormValid: boolean = true;
  isNameValid: boolean = true;
  isPhoneValid: boolean = true;
  imageSrcs: string[] = [];
  deviceData: any = {};
  deviceData$: any = null;
  languageIndex: number = 0;
  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  constructor(
    private router: Router,
    private genericService: GenericService,
    private crowdinService: CrowdinService,
    private landingService: LandingService,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();

    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;
    this.currentLanguage = selectedName;

    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  navigate() {
    const name = document.getElementById('name') as HTMLInputElement;
    const phone = document.getElementById('phone') as HTMLInputElement;
    if (name?.value || phone?.value) {
      this.isFormValid = true;
      this.deviceData['languageSelected'] = this.currentLanguage;
      this.genericService.setLocalStorage(this.deviceData);
      this.genericService.deviceData.next(this.deviceData);
      this.router.navigate(['/esrSummary']);
    } else {
      if (name?.value == null || name?.value == '') this.isNameValid = false;
      else this.isNameValid = true;
      if (phone?.value == null || phone?.value == '') this.isPhoneValid = false;
      else this.isPhoneValid = true;
      this.isFormValid = false;
      return;
    }
  }

  onNameChange() {
    const name = document.getElementById('name') as HTMLInputElement;
    if (name?.value == null || name?.value == '') this.isNameValid = false;
    else this.isNameValid = true;

    const phone = document.getElementById('phone') as HTMLInputElement;
    if (name?.value && phone?.value) this.isFormValid = true;
    else this.isFormValid = false;
  }

  onTelChange() {
    const phone = document.getElementById('phone') as HTMLInputElement;
    if (phone?.value == null || phone?.value == '') this.isPhoneValid = false;
    else this.isPhoneValid = true;

    const name = document.getElementById('name') as HTMLInputElement;
    if (name?.value && phone?.value) this.isFormValid = true;
    else this.isFormValid = false;
  }

  onFilesSelected(event: Event): void {
    const files = (event.target as HTMLInputElement).files;
    if (files) {
      // this.imageSrcs;
      Array.from(files).forEach((file) => {
        const reader = new FileReader();
        reader.onload = (e) => this.imageSrcs.push(e.target?.result as string);
        reader.readAsDataURL(file);
      });
    }
  }

  removeimage(fileindex: any) {
    this.imageSrcs.splice(fileindex, 1);
  }

  niceChat() {
    // const element = document.querySelector('[data-selector=GUIDE_CHANNEL_BUTTON]') as HTMLElement;
    // element.style.visibility = "visible";
    // if (element) {
    //   element.click();
    // }
  }
}
